// tslint:disable: no-console
import { register } from 'register-service-worker';
import pkg from '../package.json';

if (process.env.NODE_ENV === 'production') {
    const version = `${pkg.name}-${pkg.version}`;
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB',
            );
        },
        registered() {
            console.log('Service worker has been registered.');
        },
        cached() {
            console.log('Content has been cached for offline use.');
        },
        updatefound() {
            console.log('New content is downloading.');
        },
        updated() {
            // caches.keys().then((cacheNames: any) => {
            //     if (cacheNames) {
            //         cacheNames.map((cacheName: any) => {
            //             // 如果当前版本和缓存版本不一致
            //             if (cacheName && cacheName !== version) {
            //                 caches.delete(cacheName).then(() => {
            //                     //
            //                 }).catch(() => {
            //                     //
            //                 });
            //             }
            //             return cacheName;
            //         });
            //     }
            // });
            console.log(`New content is available; please refresh.${version}`);
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.');
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        },
    });
}
